import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Screen } from '../../components/Screen/Screen';
import { ScreenHeader } from '../../components/ScreenHeader/ScreenHeader';
import { ProgressIndicator } from '../../components/ProgressIndicator/ProgressIndicator';
import { Button } from '../../components/Button/Button';
import { copy, labels } from '../../constants';
import { useOnboardingStore } from '../../store/onboarding';
import type { ForWhom } from '../../types';

export const WhoIsThisFor: React.FC = () => {
  const navigate = useNavigate();
  const { updateData, setStep } = useOnboardingStore();

  const handleSelect = (value: ForWhom) => {
    updateData({ for_whom: value });
    setStep(3);
    navigate('/help-type');
  };

  return (
    <Screen>
      <ProgressIndicator currentStep={2} totalSteps={8} />
      
      <ScreenHeader
        title={copy.forWhom.title}
        subtitle={copy.forWhom.subtitle}
      />
      
      <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--spacing-sm)' }}>
        <Button
          variant="outline"
          size="large"
          fullWidth
          onClick={() => handleSelect('myself')}
        >
          {labels.forWhom.myself}
        </Button>
        
        <Button
          variant="outline"
          size="large"
          fullWidth
          onClick={() => handleSelect('someone-i-care-about')}
        >
          {labels.forWhom['someone-i-care-about']}
        </Button>
      </div>
    </Screen>
  );
};
